/* istanbul ignore file */
import React from 'react'
import PropTypes from 'prop-types'
import { withTheme } from 'styled-components'

const Icon = ({ theme, color }) => <svg width='15' height='14' viewBox='0 0 15 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path fillRule='evenodd' clipRule='evenodd' d='M13.625 7C13.625 10.3137 10.9387 13 7.625 13C4.31129 13 1.625 10.3137 1.625 7C1.625 3.68629 4.31129 1 7.625 1C10.9387 1 13.625 3.68629 13.625 7ZM14.625 7C14.625 10.866 11.491 14 7.625 14C3.75901 14 0.625 10.866 0.625 7C0.625 3.13401 3.75901 0 7.625 0C11.491 0 14.625 3.13401 14.625 7ZM6.22855 4.89645C6.03329 4.70118 5.71671 4.70118 5.52145 4.89645C5.32618 5.09171 5.32618 5.40829 5.52145 5.60355L6.91789 7L5.52145 8.39645C5.32618 8.59171 5.32618 8.90829 5.52145 9.10355C5.71671 9.29882 6.03329 9.29882 6.22855 9.10355L7.625 7.70711L9.02145 9.10355C9.21671 9.29882 9.53329 9.29882 9.72855 9.10355C9.92382 8.90829 9.92382 8.59171 9.72855 8.39645L8.33211 7L9.72855 5.60355C9.92382 5.40829 9.92382 5.09171 9.72855 4.89645C9.53329 4.70118 9.21671 4.70118 9.02145 4.89645L7.625 6.29289L6.22855 4.89645Z'
      fill={theme.colors[color]}/>
</svg>

Icon.propTypes = {
    theme: PropTypes.object,
    color: PropTypes.string,
}

export default withTheme(Icon)
